import React from "react";
import { array } from "prop-types";

import LeftImageRightNews from "../../../molecules/LeftImageRightNews";

import "./organism2.m.css";

const Organism2 = ({ stories = [] }) => {
  if (!stories.length) {
    return null;
  }

  return (
    <div styleName="wrapper">
      {stories.map(({ story }, index) => (
        <LeftImageRightNews story={story} key={index} widths={[200, 250, 200]} />
      ))}
    </div>
  );
};

Organism2.propTypes = {
  stories: array.isRequired,
};

export default Organism2;
